"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getFormations(home, away) {
    const formations = {};
    const substitutions = [
        ...copyWithTeam(home.substitutions, home),
        ...copyWithTeam(away.substitutions, away)
    ];
    const changes = [
        ...copyWithTeam(home.changes, home),
        ...copyWithTeam(away.changes, away)
    ];
    const redcards = [
        ...copyWithTeam(home.redcards, home),
        ...copyWithTeam(away.redcards, away)
    ];
    const changesTimes = getTimesForFormation(substitutions, changes, redcards);
    formations[1] = [
        ...copyWithTeam(home.players, home),
        ...copyWithTeam(away.players, away)
    ];
    let previousFormationIndex = 1;
    changesTimes.forEach(time => {
        formations[time] = formations[previousFormationIndex].slice(0);
        redcards.forEach(card => {
            if (card.frame === time) {
                formations[time] = formations[time].filter(p => card.player._id !== p.player._id);
            }
        });
        substitutions.forEach(sub => {
            if (sub.frame === time) {
                const subIndex = formations[time].findIndex(p => sub.player._id === p.player._id);
                formations[time][subIndex] = Object.assign(Object.assign({}, sub), { player: sub.substitute });
            }
        });
        changes.forEach(change => {
            if (change.frame === time) {
                const changeIndex = formations[time].findIndex(p => change.player._id === p.player._id);
                formations[time][changeIndex] = Object.assign(Object.assign({}, formations[time][changeIndex]), { data_position: change.data_position, position: change.position });
            }
        });
        previousFormationIndex = time;
    });
    return formations;
}
function getTimesForFormation(subs, changes, redcards) {
    const changesTimes = [];
    subs.forEach(s => {
        if (!changesTimes.includes(s.frame)) {
            changesTimes.push(s.frame);
        }
    });
    changes.forEach(c => {
        if (!changesTimes.includes(c.frame)) {
            changesTimes.push(c.frame);
        }
    });
    redcards.forEach(r => {
        if (!changesTimes.includes(r.frame)) {
            changesTimes.push(r.frame);
        }
    });
    return changesTimes.sort((a, b) => a - b);
}
function copyWithTeam(array, formation) {
    return array.map(i => (Object.assign(Object.assign({}, i), { team: formation.team })));
}
exports.default = getFormations;
